import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#a)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#000",
    d: "M3 0c-.827 0-1.5.673-1.5 1.5v2.25H3V1.5h5.313L9 2.187V3.75h1.5V2.187a1.5 1.5 0 0 0-.438-1.062L9.375.438A1.5 1.5 0 0 0 8.313 0zm6 8.25v2.25H3V8.25zm1.5.75h.75a.75.75 0 0 0 .75-.75V6c0-.827-.673-1.5-1.5-1.5h-9C.673 4.5 0 5.173 0 6v2.25c0 .415.335.75.75.75h.75v1.5c0 .827.673 1.5 1.5 1.5h6c.827 0 1.5-.673 1.5-1.5zm-.375-2.062a.56.56 0 0 1-.562-.563.561.561 0 1 1 1.125 0c0 .312-.251.563-.563.563"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "a" }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "#fff",
      d: "M0 0h12v12H0z"
    })
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }